import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Input, Row, Col } from "reactstrap";
import { categories } from "../../enums/CategoriesEnum";
import { SingleReview } from "../../models/Cosmetic";
import { profileService } from "../../services/profileService";
import Image from "../Image";
import { types } from "../../enums/TypesEnum";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { Profile } from "../../models/Profile";
import UserHeader from "./UserHeader";
import CosmeticFilters from "../CosmeticFilters";

const UserProfile = () => {
  const [reviews, setReviews] = useState<SingleReview[]>([]);
  const [userProfile, setUserProfile] = useState<Profile>();
  const [loading, setLoading] = useState<boolean>(true);
  const [pickedCategory, setPickedCategory] = useState<string>();
  const [pickedType, setPickedType] = useState<string>();
  const location = useLocation();
  const profileUser = location.pathname.substring(
    location.pathname.lastIndexOf("/") + 1
  );
  const populateData = async () => {
    let userProfile = await profileService.getReviews(profileUser);
    setUserProfile(userProfile);
    let reviews = userProfile.reviews;
    if (pickedCategory) {
      reviews = reviews.filter((x) => x.category === pickedCategory);
    }
    if (pickedType) {
      reviews = reviews.filter((x) => x.type === pickedType);
    }
    setReviews(reviews);
    setLoading(false);
  };

  useEffect(() => {
    populateData();
  }, [location, pickedCategory, pickedType]); // eslint-disable-line react-hooks/exhaustive-deps

  const language = "pl";

  const navigate = useNavigate();
  const cosmeticClickHandler = (name: string) => navigate(`/cosmetic/${name}`);

  const searchHandler = async (e: any) => {
    setLoading(true);
    const value = e.target.value;
    if (value.length > 3) {
      let reviews = await profileService.getFilteredReviews(profileUser, value);
      setReviews(reviews);
      setLoading(false);
    }
    if (value.length === 0) {
      await populateData();
    }
  };

  return (
    <div>
      <UserHeader userProfile={userProfile} />
      <Row style={{ marginBottom: 10 }}>
        <Col sm={{ offset: 3, size: 6 }} xs={12}>
          <Input
            className="search"
            onChange={searchHandler}
            type="text"
            placeholder="Wyszukaj"
          />
        </Col>
      </Row>
      <CosmeticFilters
        pickedCategory={pickedCategory}
        pickedType={pickedType}
        setPickedCategory={setPickedCategory}
        setPickedType={setPickedType}
      />
      {loading ? (
        <div className="spinner" />
      ) : (
        <div className="wrap">
          {reviews.map((cosmetic: SingleReview, index) => (
            <div
              className="shadow-box review-tile-useprofile"
              key={index}
              onClick={() => cosmeticClickHandler(cosmetic?.guid || "")}
            >
              <Row>
                <Col>
                  <Image
                    guid={cosmetic.guid}
                    category={cosmetic?.category}
                    width={210}
                    height={180}
                  />
                </Col>
                <Col>
                  <Row>
                    <Col xs={8} />
                    <Col xs={4}>
                      <FontAwesomeIcon color="lightgrey" icon={faStar} />{" "}
                      <b>{cosmetic.grade}</b>
                    </Col>
                  </Row>
                  <Row>
                    <h6>
                      {categories
                        .find((x) => x.value === cosmetic.category)
                        ?.translations.find((x) => x.language === language)
                        ?.name ?? cosmetic.category}{" "}
                      -{" "}
                      {
                        types
                          .find((x) => x.category === cosmetic?.category)
                          ?.values.find((xx) => xx.value === cosmetic?.type)
                          ?.translations.find((xxx) => xxx.language === "pl")
                          ?.name
                      }
                    </h6>
                  </Row>
                  <Row>
                    <h6>{cosmetic?.brand}</h6>
                  </Row>
                  <Row>
                    <h5 style={{ fontWeight: "bold", padding: "10" }}>
                      {cosmetic?.name}
                    </h5>
                  </Row>
                  {cosmetic.color !== "default" && (
                    <Row>Odcień: {cosmetic.color}</Row>
                  )}
                </Col>
              </Row>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UserProfile;

//<Row>
//    <img src={cosmetic?.image ? cosmetic?.image : (categories?.find(x => x.value === cosmetic?.category)?.image ?? categories[0].image)} alt="cosmetic" />
//</Row>
//<Row><h5 style={{ width: '100%', textAlign: 'center', padding: 5 }}> Ocena: <b>{cosmetic.averageGrade}</b></h5></Row>
